import React, { useState } from "react";
import classes from "./InputDragAndDrop.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

interface Interface {
  danger?: any;
  faIcon?: any;
  afterDropFile?: any;
  onStartToDrop?: any;
}
export default function InputDragAndDrop({
  danger = null,
  faIcon = null,
  afterDropFile = null,
  onStartToDrop = null,
}: Interface) {
  const { t } = useTranslation();
  const [stateClass, setStateClass] = useState(false);
  const isAdvancedUpload = (function () {
    const div = document.createElement("div");
    return (
      ("draggable" in div || ("ondragstart" in div && "ondrop" in div)) &&
      "FormData" in window &&
      "FileReader" in window
    );
  })();

  let boxClasses = classes.Box + " " + stateClass;
  if (danger) boxClasses += " " + classes.Danger;
  if (stateClass) boxClasses += " " + classes.Dragover;
  if (isAdvancedUpload) boxClasses += " " + classes.HasAdvUpload;

  let _faIcon = faCloudUploadAlt;
  if (faIcon) _faIcon = faIcon;

  const onDragBaseHelper = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const onDragoverHelper = (e: any) => {
    onDragBaseHelper(e);
    setStateClass(true);
    if (onStartToDrop)
      try {
        onStartToDrop(e);
      } catch (error) {
        console.error("[InputDragAndDrop - error", error);
      }
  };
  const onDragDropLeaveEndHelper = (e: any) => {
    onDragBaseHelper(e);
    setStateClass(false);
  };

  const onDropHelper = (e: any) => {
    onDragBaseHelper(e);
    setStateClass(false);
    if (afterDropFile)
      try {
        afterDropFile(e.dataTransfer.files);
      } catch (error) {
        console.error("[InputDragAndDrop - onDropHelper()]", error);
      }
  };

  const onChangeHelper = (e: any) => {
    if (onStartToDrop) onStartToDrop();
    e.preventDefault();
    if (afterDropFile)
      try {
        afterDropFile(e.target.files);
      } catch (error) {
        console.error("[InputDragAndDrop - onChangeHelper()]", error);
      }
  };

  const _dragAndDropContent = (
    <form
      className={boxClasses}
      method="post"
      action=""
      encType="multipart/form-data"
      onDragStart={(e) => onDragBaseHelper(e)}
      onDragEnter={(e) => onDragoverHelper(e)}
      onDrag={(e) => onDragBaseHelper(e)}
      onDragOver={(e) => onDragoverHelper(e)}
      onDragEnd={(e) => onDragDropLeaveEndHelper(e)}
      onDragLeave={(e) => onDragDropLeaveEndHelper(e)}
      onDrop={(e) => onDropHelper(e)}
    >
      <span className={classes.InfoToDrop}>{t("global.drop")}</span>
      <div className={classes.InnerBox}>
        <FontAwesomeIcon className={classes.Icon} icon={_faIcon} />
        {/* <div className={classes.Input}> */}
        <input
          className={classes.File}
          type="file"
          name="files[]"
          id="file"
          onChange={onChangeHelper}
          multiple
          accept=".xlsx"
          data-multiple-caption="{count} files selected"
        />
        <label htmlFor="file">
          <strong tabIndex={0} className={classes.BtnUpload}>
            {t("global.search")}
          </strong>{" "}
          <span className={classes.Dragndrop}>
            {t("global.or_drag_the")} modelo_planilha_funcionarios.xlsx
          </span>
        </label>
        <p className={classes.BottomInfo}>
          <small>
            <strong>*{t("global.attention")}, </strong>{" "}
            {t("global.file_must_be_equals_as_model")}
          </small>
        </p>
        <button className={classes.BtnSubmit} type="submit">
          {t("global.send")}
        </button>
        {/* </div> */}

        <div className={classes.Uploading}>{t("global.uploading")}...</div>
        <div className={classes.Success}>{t("global.done")}!</div>
        <div className={classes.Error}>{t("global.error")}!</div>
      </div>
    </form>
  );
  return _dragAndDropContent;
}
